import React, { useState, useEffect, useRef } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import { useInView } from "react-intersection-observer";
import ListItemText from '@mui/material/ListItemText';
import TR from './../../Trans';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import SvgIcon from '@mui/material/SvgIcon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { ReactComponent as AutoTrackIcon } from './../../assets/auto-track.svg';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MuvikaService from './../../services/muvika';
import CreatorsDialog from '../dialogs/CreatorsDialog';
import AlbumIcon from '@mui/icons-material/Album';
import IconButton from '@mui/material/IconButton';
import sessionStore from '../../stores/session';
import playerStore from './../../stores/player';
import singersStore from '../../stores/singers';
import bgPerformanceStore from '../../stores/bgPerformance';
import messageStore from '../../stores/message';
import musicPlayerStore from '../../stores/musicPlayer';

function BackgroundMusicListItem(props) {

  const thisPerformance = bgPerformanceStore((state) => state.playQueue?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const moveTop = bgPerformanceStore((state) => state.moveToTop);
  const moveSecond = bgPerformanceStore((state) => state.moveToSecond);
  const moveLast = bgPerformanceStore((state) => state.moveToBottom);
  const moveUp = bgPerformanceStore((state) => state.moveUp);
  const moveDown = bgPerformanceStore((state) => state.moveDown);
  const deletePerformance = bgPerformanceStore((state) => state.deletePerformance);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  const setError = messageStore((state) => state.setError);
  const isPaused = musicPlayerStore((state) => state.isPaused);
  const isPlayerStopped = playerStore((state) => state.isStopped);
  const setIsPaused = musicPlayerStore((state) => state.setIsPaused);
  const isMusicOn = musicPlayerStore((state) => state.isMusicOn);
  const getStreamUrl = musicPlayerStore((state) => state.getStreamUrl);
  const streamUrl = musicPlayerStore((state) => state.streamUrl);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);
  const currentPerformance = bgPerformanceStore((state) => state.currentPerformance);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [creators, setCreators] = useState(null);
  const [showEqualizer, setShowEqualizer] = useState(true);
  const itemRef = useRef();

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
  }, []);

  const getCreators = () => {
    if (thisPerformance) {
      if (thisPerformance?.track) {
        if (thisPerformance?.track.track_id) {
          MuvikaService.getTrackCreators(sessionToken, thisPerformance?.track.track_id)
            .then(function (res) {
              if (res.data.data) {
                if (res.data.error) {
                  setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
                } else {
                  setCreators(res.data.data.items);
                }
              }
            })
            .catch(function () { });
        }
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
    if(itemRef){
      if(itemRef.current){
        itemRef.current.style.background="unset";
      }
    }
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
    if(itemRef){
      if(itemRef.current){
        itemRef.current.style.background="rgba(255, 255, 255, 0.08) !important";
      }
    }
  };

  const handleMoveToTop = () => {
    moveTop(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveToBottom = () => {
    moveLast(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveUp = () => {
    moveUp(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveSecond = () => {
    moveSecond(sessionToken, thisPerformance?.unique_id);
  };

  const handleMoveDown = () => {
    moveDown(sessionToken, thisPerformance?.unique_id);
  };

  const renderMoveToFirst = () => {
    if (props.index > 0) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();
        handleMenuClose();
        handleMoveToTop();
      }}>{TR.cm_move_to_now_playing}</MenuItem>;
    }
  };

  const renderMoveToSecond = () => {
    if (props.count > 1 && props.index != 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveSecond();
      }}>{TR.cm_move_to_second}</MenuItem>;
    }
  };

  const renderMoveUp = () => {
    if (props.index > 0) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveUp();
      }}>{TR.cm_move_up}</MenuItem>;
    }
  };

  const renderMoveDown = () => {
    if (props.index < props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveDown();
      }}>{TR.cm_move_down}</MenuItem>;
    }
  };

  const renderMoveToLast = () => {
    if (props.index != props.count - 1) {
      return <MenuItem onClick={(e) => {
        e.stopPropagation();
        handleMenuClose();
        handleMoveToBottom();
      }}>{TR.cm_move_to_bottom}</MenuItem>;
    }
  };

  const renderDelete = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      handleMenuClose();
      deletePerformance(sessionToken, thisPerformance?.unique_id);
    }}>{TR.cm_delete}</MenuItem>;
  };

  const primaryText = () => {
    return <div>
      {thisPerformance?.track.title}
    </div>;
  };

  const secondaryText = thisPerformance?.track.artist;

  const showIcon = () => {
    if (!isPaused.isPaused) {
      if (showEqualizer && isPlayerStopped.isStopped) {
        return <div><img className="muvika-icon performance-list-item-icon" src="./eq.gif" /></div>;
      } else {
        return <PauseIcon />;
      }
    } else {
      return <PlayArrowIcon />;
    }
  };

  const handlePlayPause = (e) => {
    e.stopPropagation();
    if (isPaused.isPaused) {
      if (!isPlayerStopped.isStopped) {
        setIsPaused(false);
      } else {
        if (isMusicOn) {
          if (streamUrl.length == 0) {
            console.log("stream_url_get");
            getStreamUrl(sessionToken, currentPerformance, currentTrack, singers[0], true);
          } else {
            setIsPaused(false);
          }
        }
      }
    } else {
      setIsPaused(true);
    }
  };

  const renderAutoAddedIcon = () => {
    if (thisPerformance?.flags) {
      if (thisPerformance?.flags.includes("auto_added")) {
        return <SvgIcon component={AutoTrackIcon} />;
      }
    }
    return <AlbumIcon />;
  };

  const renderAvatar = () => {
    if (thisPerformance?.position == 0) {
      return <ListItemAvatar onMouseOver={() => setShowEqualizer(false)} onMouseOut={() => setShowEqualizer(true)} onClick={handlePlayPause} className="muvika-track-avatar-item">
        <ListItemIcon>
          {showIcon()}
        </ListItemIcon>
      </ListItemAvatar>;
    } else {
      return <ListItemAvatar className="muvika-track-avatar-item">
        <ListItemIcon>
          {renderAutoAddedIcon()}
        </ListItemIcon>
      </ListItemAvatar>;
    }
  };

  const renderListItem = () => {
    console.log("render hard element");
    if (thisPerformance) {
      return <div>
        <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={thisPerformance?.track} />
        <ListItemButton 
        ref={itemRef}
        sx={{
          lineHeight: 0.9,
          paddingLeft: "0.75rem !important",
          margin: 0,
          bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08) !important' : 'unset'
        }}
          selected={props.index === 0}
          onClick={() => props.onEditPerformance(thisPerformance)}
        >
          {renderAvatar()}
          <ListItemText primary={primaryText()} secondary={secondaryText} />
          <ListItemText className="muvika-list-right-playlists" secondary={thisPerformance?.track.kcode} />
          <IconButton
            id={"music-menu-button-" + props.index}
            color="white"
            component="label"
            size="small"
            aria-controls={isMenuOpen ? "music-menu-" + props.index : undefined}
            aria-haspopup="true"
            aria-expanded={isMenuOpen ? 'true' : undefined}
            onClick={(e) => {
              e.stopPropagation();
              openMenu(e);
            }}>
            <MenuIcon />
          </IconButton>
          <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
            id={"music-menu-" + props.index}
            open={isMenuOpen}
            anchorEl={anchorEl}
            onClose={(e) => {
              e.stopPropagation();
              handleMenuClose();
            }}
            MenuListProps={{
              'aria-labelledby': 'music-menu-button-' + props.index,
            }}
          >
            {renderMoveToFirst()}
            {renderMoveToSecond()}
            {renderMoveUp()}
            {renderMoveDown()}
            {renderMoveToLast()}
            {renderDelete()}
          </Menu>
        </ListItemButton>
      </div>;
    }
  };

  return (
    <Draggable
      key={props.key}
      draggableId={props.draggableId}
      index={props.index}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {renderListItem()}
        </div>
      )}
    </Draggable>
  );
}

export default BackgroundMusicListItem;